import { css } from '@emotion/react'
import styled from '@emotion/styled'
import { WIDGET_SIZES } from '@liveHelper/components/shared/WidgetContainer/WidgetContainer.styles'
import type { WidgetState } from '@liveHelper/models/fsm/machine'
import { FlexCenter, Transition } from '@oneToOne/shared/styles'

export const QueuePositionContainer = styled.div<{
  topLevelUIState: WidgetState
  isMobileWeb: boolean
}>`
  ${Transition}
  ${FlexCenter}
  position: relative;
  flex-grow: 1;
  flex-direction: column;
  overflow: hidden;
  background: var(--gray-10);
  cursor: pointer;
  border-radius: var(--border-radius-md);

  width: 100%;
  height: 100%;

  ${({ isMobileWeb, topLevelUIState }) =>
    !isMobileWeb &&
    css`
      min-width: ${
        topLevelUIState === 'minimized'
          ? WIDGET_SIZES.minimized.default.width
          : WIDGET_SIZES.expanded.default.width
      };
      max-height: 100vh;
      max-width: 100vw;
    `}/* Because of the animation to grow the chat container, we need to set a min-width to prevent the chat from shrinking to 0 width when the chat is minimized.
  The reason for this, is longer messages look very awkward when growing from a more minimized state to the chatting default width and height. */
`

export const QueueText = styled.p<{ large?: boolean }>`
  color: var(--white);
  font-size: ${(props) =>
    props.large ? 'var(--font-size-lg)' : 'var(--font-size-xxs)'};
  font-weight: var(--font-medium);
  text-align: center;
  padding: 0 var(--spacing-6);
  margin: var(--spacing-6) 0;
`

export const QueuePositionNumber = styled.p`
  color: var(--gray-10);
  font-weight: var(--font-semibold);
  font-size: var(--font-size-lg);
  text-align: center;
  background-color: var(--white);
  border-radius: 50px;
  width: 50px;
  height: 50px;
  line-height: 50px;
  margin: var(--spacing-6) 0;
`
